module.exports = __webpack_public_path__ + "img/rc-bottom.9a9af191.png";